// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TO-z","hovered":"UO-z","hoverImage":"VO-z","mainImage":"WO-z","imageNoBackground":"XO-z","fullSizeImage":"YO-z"};